// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-header {
  color: #53aae5;
  border-block-color: rgb(88, 91, 92);
  font-size: large;
}

.agentProfileData {
  display: flex;
  margin-bottom: 20px;
}
.agentProfileData label {
  min-width: 50%;
  margin-right: 15px;
}
.agentProfileData span {
  flex-grow: 1;
}

.profile-pic {
  width: 200px;
  max-height: 200px;
  display: inline-block;
}

.file-upload {
  display: none;
}

.circle {
  border-radius: 100% !important;
  overflow: hidden;
  width: 200px;
  height: 200px;
  border: 2px solid rgba(255, 255, 255, 0.2);
}

img {
  max-width: 100%;
  height: auto;
}

.uploadIcon {
  font-size: 17px;
  color: blue;
  cursor: pointer;
}

.editButton {
  padding: 0 !important;
  border: none !important;
  background: none !important;
}

button:focus {
  outline: none;
}

.profile-container {
  display: flex;
  justify-content: center;
  padding: 2rem;
  box-sizing: border-box;
  border-radius: 10px;
}

.profile-card {
  display: flex;
  flex-direction: column;
  background: linear-gradient(90deg, rgb(16, 4, 208) 0%, rgb(13, 113, 232) 35%, rgb(67, 216, 246) 100%);
  color: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 1rem;
  overflow: hidden;
  width: 100%;
  padding: 20px;
  max-width: 70%;
  text-align: center;
}

.profile-image {
  width: 120px;
  height: 120px;
  object-fit: cover;
  border-radius: 50%;
  border: 4px solid white;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  line-height: 135px;
}

.info-section {
  padding: 1.5rem;
}

.info-section .agent-name {
  align-items: center;
}

.agent-name {
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
}

.agent-role {
  color: #666;
  margin-bottom: 1rem;
}

.agent-contact p {
  margin: 0.3rem 0;
}

.image-section,
.info-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.info-section .agent-contact {
  align-items: flex-start;
  padding: 2rem;
  margin-top: 10px;
}

.profile-image {
  width: 150px;
  height: 150px;
}

.contact-row {
  display: flex;
  justify-content: space-between;
  margin: 0.4rem 0;
  font-size: 0.95rem;
}

.agentReviewApplndata {
  display: flex;
  align-items: start;
  margin-bottom: 10px;
  color: #fff;
  font-weight: 500;
}
.agentReviewApplndata label {
  width: 20%;
  text-align: left;
  margin-left: 25%;
  color: #fff;
  white-space: nowrap;
}
.agentReviewApplndata span {
  flex: 1;
  text-align: left;
  word-break: break-word;
  color: #fff;
  margin-left: 10%;
}

.stepTop {
  padding-top: 1% !important;
}

hr:not([size]) {
  height: 3px;
  margin-top: -20px;
}

.profileCard {
  border: 5px solid #36f;
}

.profile-card {
  position: relative;
  background: linear-gradient(135deg, #2b0bdb, #00cfff);
  border-radius: 15px;
  color: white;
  padding: 30px;
  width: 80%;
  margin: auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

/* Edit icon button */
.edit-btn {
  position: absolute;
  top: 15px;
  right: 15px;
  background: white;
  color: #007bff;
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.edit-btn:hover {
  background: #007bff;
  color: white;
  border: 2px solid #ffffff; /* Added white border on hover */
  transform: scale(1.1);
}

.edit-btn i {
  font-size: 16px;
}`, "",{"version":3,"sources":["webpack://./src/app/agent/agent-profile/agent-profile.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,mCAAA;EACA,gBAAA;AACF;;AACA;EACE,aAAA;EACA,mBAAA;AAEF;AADE;EACE,cAAA;EACA,kBAAA;AAGJ;AADE;EACE,YAAA;AAGJ;;AACA;EACE,YAAA;EACA,iBAAA;EACA,qBAAA;AAEF;;AACA;EACE,aAAA;AAEF;;AAAA;EACE,8BAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,0CAAA;AAGF;;AADA;EACE,eAAA;EACA,YAAA;AAIF;;AADA;EACE,eAAA;EACA,WAAA;EACA,eAAA;AAIF;;AADA;EACE,qBAAA;EACA,uBAAA;EACA,2BAAA;AAIF;;AADA;EACE,aAAA;AAIF;;AADA;EACE,aAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAIF;;AADA;EACE,aAAA;EACA,sBAAA;EACA,qGAAA;EAMA,YAAA;EACA,wCAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;AADF;;AAIA;EACE,YAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;EACA,wCAAA;EACA,kBAAA;AADF;;AAIA;EACE,eAAA;AADF;;AAIA;EACE,mBAAA;AADF;;AAGA;EACE,iBAAA;EACA,iBAAA;EACA,qBAAA;AAAF;;AAGA;EACE,WAAA;EACA,mBAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;;EAEE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,uBAAA;EACA,aAAA;EACA,gBAAA;AAAF;;AAGA;EACE,YAAA;EACA,aAAA;AAAF;;AAGA;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;AAAF;AAEE;EACE,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;AAAJ;AAGE;EACE,OAAA;EACA,gBAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;AADJ;;AAKA;EACE,0BAAA;AAFF;;AAKA;EACE,WAAA;EACA,iBAAA;AAFF;;AAKA;EACE,sBAAA;AAFF;;AAKA;EACE,kBAAA;EACA,qDAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,YAAA;EACA,yCAAA;AAFF;;AAIA,qBAAA;AACA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;AADF;;AAIA;EACE,mBAAA;EACA,YAAA;EACA,yBAAA,EAAA,gCAAA;EACA,qBAAA;AADF;;AAIA;EACE,eAAA;AADF","sourcesContent":[".card-header {\n  color: #53aae5;\n  border-block-color: rgb(88, 91, 92);\n  font-size: large;\n}\n.agentProfileData {\n  display: flex;\n  margin-bottom: 20px;\n  label {\n    min-width: 50%;\n    margin-right: 15px;\n  }\n  span {\n    flex-grow: 1;\n  }\n}\n\n.profile-pic {\n  width: 200px;\n  max-height: 200px;\n  display: inline-block;\n}\n\n.file-upload {\n  display: none;\n}\n.circle {\n  border-radius: 100% !important;\n  overflow: hidden;\n  width: 200px;\n  height: 200px;\n  border: 2px solid rgba(255, 255, 255, 0.2);\n}\nimg {\n  max-width: 100%;\n  height: auto;\n}\n\n.uploadIcon {\n  font-size: 17px;\n  color: blue;\n  cursor: pointer;\n}\n\n.editButton {\n  padding: 0 !important;\n  border: none !important;\n  background: none !important;\n}\n\nbutton:focus {\n  outline: none;\n}\n\n.profile-container {\n  display: flex;\n  justify-content: center;\n  padding: 2rem;\n  box-sizing: border-box;\n  border-radius: 10px;\n}\n\n.profile-card {\n  display: flex;\n  flex-direction: column;\n  background: linear-gradient(\n    90deg,\n    rgba(16, 4, 208, 1) 0%,\n    rgba(13, 113, 232, 1) 35%,\n    rgba(67, 216, 246, 1) 100%\n  );\n  color: white;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  border-radius: 1rem;\n  overflow: hidden;\n  width: 100%;\n  padding: 20px;\n  max-width: 70%;\n  text-align: center;\n}\n\n.profile-image {\n  width: 120px;\n  height: 120px;\n  object-fit: cover;\n  border-radius: 50%;\n  border: 4px solid white;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);\n  line-height: 135px;\n}\n\n.info-section {\n  padding: 1.5rem;\n}\n\n.info-section .agent-name {\n  align-items: center;\n}\n.agent-name {\n  font-size: 1.5rem;\n  font-weight: bold;\n  margin-bottom: 0.5rem;\n}\n\n.agent-role {\n  color: #666;\n  margin-bottom: 1rem;\n}\n\n.agent-contact p {\n  margin: 0.3rem 0;\n}\n\n.image-section,\n.info-section {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.info-section .agent-contact {\n  align-items: flex-start;\n  padding: 2rem;\n  margin-top: 10px;\n}\n\n.profile-image {\n  width: 150px;\n  height: 150px;\n}\n\n.contact-row {\n  display: flex;\n  justify-content: space-between;\n  margin: 0.4rem 0;\n  font-size: 0.95rem;\n}\n\n.agentReviewApplndata {\n  display: flex;\n  align-items: start;\n  margin-bottom: 10px;\n  color: #fff;\n  font-weight: 500;\n\n  label {\n    width: 20%;\n    text-align: left;\n    margin-left: 25%;\n    color: #fff;\n    white-space: nowrap;\n  }\n\n  span {\n    flex: 1;\n    text-align: left;\n    word-break: break-word;\n    color: #fff;\n    margin-left: 10%;\n  }\n}\n\n.stepTop {\n  padding-top: 1% !important;\n}\n\nhr:not([size]) {\n  height: 3px;\n  margin-top: -20px;\n}\n\n.profileCard {\n  border: 5px solid #36f;\n}\n\n.profile-card {\n  position: relative;\n  background: linear-gradient(135deg, #2b0bdb, #00cfff);\n  border-radius: 15px;\n  color: white;\n  padding: 30px;\n  width: 80%;\n  margin: auto;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n/* Edit icon button */\n.edit-btn {\n  position: absolute;\n  top: 15px;\n  right: 15px;\n  background: white;\n  color: #007bff;\n  border: none;\n  border-radius: 50%;\n  width: 40px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.edit-btn:hover {\n  background: #007bff;\n  color: white;\n  border: 2px solid #ffffff; /* Added white border on hover */\n  transform: scale(1.1);\n}\n\n.edit-btn i {\n  font-size: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
